module.exports = __webpack_public_path__ + "img/neo-ellipse.48103ddc.png";